import React from 'react'
import CopyIcon from '@rsuite/icons/Copy'
import { notifySuccess, notifyError, copyToClipboard } from 'utils'
import {
  generatePassword,
  STRONG_PASSWORD_COUNTS
} from 'utils/passwordValidation'
import './passwordActions.scss'

interface PasswordActionsProps {
  password: string
  onGenerate: (password: string) => void
  personalInfo?: (string | undefined | null)[]
  className?: string
}

const PasswordActions: React.FC<PasswordActionsProps> = ({
  password,
  onGenerate,
  personalInfo = [],
  className
}) => {
  const handleGenerate = () => {
    onGenerate(generatePassword({ ...STRONG_PASSWORD_COUNTS, personalInfo }))
  }

  const handleCopy = async () => {
    const copied = await copyToClipboard(password)
    if (copied) {
      notifySuccess('Password copied')
    } else {
      notifyError('Could not copy password')
    }
  }

  return (
    <div
      className={
        className ? `password-actions ${className}` : 'password-actions'
      }
    >
      <button
        type="button"
        className="password-actions__generate"
        onClick={handleGenerate}
      >
        Generate strong password
      </button>
      {!!password && (
        <button
          type="button"
          className="password-actions__copy"
          onClick={handleCopy}
          title="Copy password"
          aria-label="Copy password"
        >
          <CopyIcon />
        </button>
      )}
    </div>
  )
}

export default PasswordActions
